import { render, staticRenderFns } from "./createCartonOrder.vue?vue&type=template&id=b38762be&scoped=true"
import script from "./createCartonOrder.vue?vue&type=script&lang=js"
export * from "./createCartonOrder.vue?vue&type=script&lang=js"
import style0 from "./createCartonOrder.vue?vue&type=style&index=0&id=b38762be&prod&scoped=true&lang=css"
import style1 from "./createCartonOrder.vue?vue&type=style&index=1&id=b38762be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38762be",
  null
  
)

export default component.exports